import { Radio, Select } from 'antd';
import FormItem from 'antd/es/form/FormItem';
import { sortBy } from 'lodash';
import { useListLocation } from '../../utils/api-hooks/location.hook';
import { ReactNode } from 'react';

type Props = {
  label?: ReactNode;
};

export function StatementLocationFilterComponent(props: Props) {
  const { data: locations = [] } = useListLocation();

  const locationOptions = sortBy(locations, (location) =>
    parseInt(String(location.idNumber), 10)
  ).map((location) => ({
    label: `${location.idNumber} - ${location.name}`,
    value: String(location.idNumber),
  }));

  return (
    <FormItem label={props.label || '場域'}>
      <div className="space-y-2">
        <FormItem name="locationMode" noStyle>
          <Radio.Group>
            <Radio value="all">全部場域</Radio>
            <Radio value="include">只包含特定場域</Radio>
            <Radio value="exclude">排除特定場域</Radio>
          </Radio.Group>
        </FormItem>

        <FormItem
          noStyle
          shouldUpdate={(prevValues, currentValues) =>
            prevValues.locationMode !== currentValues.locationMode
          }
        >
          {({ getFieldValue }) => {
            const mode = getFieldValue('locationMode');
            if (mode === 'all') {
              return null;
            }
            return (
              <FormItem
                name="locationNumbers"
                rules={[
                  ({ getFieldValue: getFieldValueInner }) => ({
                    validator(_, value) {
                      const modeInner = getFieldValueInner('locationMode');
                      if (modeInner === 'include' || modeInner === 'exclude') {
                        if (!value || value.length === 0) {
                          return Promise.reject(
                            new Error(
                              `請選擇要${modeInner === 'include' ? '包含' : '排除'}的場域`
                            )
                          );
                        }
                      }
                      return Promise.resolve();
                    },
                  }),
                ]}
              >
                <Select
                  mode="multiple"
                  optionFilterProp="label"
                  options={locationOptions}
                  placeholder="請選擇場域"
                  showSearch
                  maxTagCount={3}
                  maxTagTextLength={10}
                  style={{ width: '100%' }}
                />
              </FormItem>
            );
          }}
        </FormItem>
      </div>
    </FormItem>
  );
}
